import { useContext } from 'react';
import EmailComponent from './EmailComponent';
import PasswordComponent from './PasswordComponent';
import { LoadingSpinner } from 'foundations-components/transitional/components/LoadingSpinner';
import { Spacer } from 'foundations-components/components/Spacer';
import styled from 'styled-components';
import { SmartLoginLandingPageContext } from './SmartLoginLandingPageContext';
import PasskeyComponent from '../passkey/PasskeyComponent';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const StyledContainer = styled.div.withConfig({
  displayName: "SmartLoginEntryForm__StyledContainer",
  componentId: "sc-1obovvm-0"
})(["max-width:370px;width:100%;"]);
const SmartLoginEntryForm = () => {
  const {
    isLoaded
  } = useContext(SmartLoginLandingPageContext);
  return /*#__PURE__*/_jsx(_Fragment, {
    children: isLoaded ? /*#__PURE__*/_jsxs(StyledContainer, {
      children: [/*#__PURE__*/_jsx(EmailComponent, {}), /*#__PURE__*/_jsx(PasskeyComponent, {}), /*#__PURE__*/_jsx(PasswordComponent, {})]
    }) : /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Spacer, {
        space: "1500"
      }), /*#__PURE__*/_jsx(LoadingSpinner, {
        grow: true,
        minHeight: "56px"
      })]
    })
  });
};
export default SmartLoginEntryForm;